import { ref } from 'vue';
import type { Ref } from 'vue';

type CallbackFunction = () => void;

export function useModal() {
  const modalId: string = "myModalId";
  const modalTitle: Ref<string> = ref("タイトル");
  const modalMessage: Ref<string> = ref("メッセージ");
  const isModalVisible: Ref<boolean> = ref(false);
  const performActionCallback: Ref<CallbackFunction | null> = ref(null);
  const cancelActionCallback: Ref<CallbackFunction | null> = ref(null);

  async function showModal( title: string, message: string,callback: CallbackFunction): Promise<void> {
    modalTitle.value = title;
    modalMessage.value = message;
    isModalVisible.value = true;
    performActionCallback.value = callback;
  }

  async function showModalYesNo( title: string, message: string,callbackYes: CallbackFunction,callbackNo: CallbackFunction): Promise<void> {
    modalTitle.value = title;
    modalMessage.value = message;
    isModalVisible.value = true;
    performActionCallback.value = callbackYes;
    cancelActionCallback.value = callbackNo;
  }


  async function closeModal(): Promise<void> {
    isModalVisible.value = false;
  }

  async function performAction(): Promise<void> {
    if (performActionCallback.value) {
       performActionCallback.value();
    }
    await closeModal();
  }

  function cancelAction(): void {
    if (cancelActionCallback.value) {
      cancelActionCallback.value();
   }
    closeModal();
  }

  return {
    modalId,
    modalTitle,
    modalMessage,
    isModalVisible,
    performActionCallback,
    cancelActionCallback,
    showModal,
    showModalYesNo,
    closeModal,
    performAction,
    cancelAction,
  };
}
